import { render, staticRenderFns } from "./ClueListN.vue?vue&type=template&id=80f9a430&scoped=true"
import script from "./ClueListN.vue?vue&type=script&lang=js"
export * from "./ClueListN.vue?vue&type=script&lang=js"
import style0 from "./ClueListN.vue?vue&type=style&index=0&id=80f9a430&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80f9a430",
  null
  
)

export default component.exports